import React, { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "p2p_cookie_consent_v1";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "dismissed");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:bottom-6 sm:max-w-md z-[60] bg-white rounded-2xl border border-amber-200 shadow-2xl p-5"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="flex items-start gap-3">
        <Cookie className="text-emerald-700 flex-shrink-0 mt-1" size={22} />
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 text-sm mb-1">A note on cookies</h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            We use a single secure cookie for admin login and collect anonymous page-view counts to understand
            which pages help families most. No personal data, no tracking, no ads. See our{" "}
            <a href="/privacy" className="text-emerald-700 font-medium hover:underline">Privacy Policy</a>.
          </p>
          <div className="flex items-center gap-3 mt-3">
            <button
              onClick={accept}
              className="bg-emerald-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-emerald-800"
              data-testid="cookie-accept"
            >
              Got it
            </button>
            <a href="/privacy" className="text-sm text-gray-600 hover:underline">Learn more</a>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="text-gray-400 hover:text-gray-700 p-1"
          aria-label="Dismiss"
          data-testid="cookie-dismiss"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
